import { memo, useEffect, useState } from 'react'

import { AnimatedSpinner } from '../AnimatedSpinner'

interface SmoothImageProps {
  src?: string
  alt?: string
  className?: string
  isFetching?: boolean
  dataTestid?: string
}

export const SmoothImage: React.FC<SmoothImageProps> = memo(
  ({ src, alt = '', className = '', dataTestid = '' }) => {
    const [loaded, setLoaded] = useState(false)
    useEffect(() => {
      setLoaded(false)
    }, [src])

    const handleImageLoad = () => {
      // Ensure opacity transition runs even if image loads instantly (e.g. from cache)
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setLoaded(true)
        })
      })
    }

    return (
      <div className={`relative ${className}`}>
        {!loaded && (
          <div className="absolute inset-0 flex items-center justify-center text-white">
            <AnimatedSpinner />
          </div>
        )}
        <img
          src={src}
          alt={alt}
          onLoad={handleImageLoad}
          className={`
            transition-opacity duration-500 ease-in-out 
            ${loaded ? 'opacity-100' : 'opacity-0'}
            w-full h-auto block
          `}
          data-testid={dataTestid}
        />
      </div>
    )
  },
)
